'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const clsx = require('clsx');
const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_17gz2_1";
const styles = {
	root: root
};

const Menu = (_a) => {
  var { children, className, role } = _a, props = tslib_es6.__rest(_a, ["children", "className", "role"]);
  return React__default.default.createElement("ul", { role, "aria-label": props["aria-label"], className: clsx__default.default(styles.root, className), "data-zds": true }, children);
};

exports.Menu = Menu;
//# sourceMappingURL=Menu.cjs.js.map
